export default __webpack_public_path__ + "static/media/eastside.ca81c823.jpg";